import { isEmpty } from 'lodash';
import React from 'react';
import { useForm } from 'react-hook-form';
import { FaBeer } from 'react-icons/fa';
import swal from 'sweetalert';
import { DateName, MonthName } from '../assets/TicketData.js';
import FromInput from '../common/FromInput.js';
const TicketSummary = ({
  selectMovie,
  selectDate,
  slectTime,
  selectType,
  count,
  selectSit,
  setCount,
  setSelectType,
  setSelectDate,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    reset();
    setCount(0);
    setSelectType(0);
    setSelectDate('');
    swal('Successfully Purchase!', '', 'success', {
      button: 'Close',
    });
    console.log(data);
  };
  return (
    <>
      <div className='max-w-md '>
        <h2 className='font-semibold text-xl py-5 text-left'>
          Tickets Summary
        </h2>
        <div className='bg-white p-5 rounded-md  text-[#8b8f9c] shadow-lg my-5'>
          {isEmpty(selectMovie) && (
            <div className='flex'>
              <span className='w-[50%] h-40  rounded-xl mr-2 bg-gray-200 '></span>
              <div className='mt-2 w-full mb-8'>
                <ul className='mt-5 space-y-3'>
                  <li className='w-[60%] h-3 bg-gray-200 rounded-md '></li>
                  <li className='w-[75%] h-3 bg-gray-200 rounded-md '></li>
                </ul>
              </div>
            </div>
          )}
          {!isEmpty(selectMovie) && (
            <div className=''>
              <img
                className='w-[30%] h-auto rounded-xl mr-2'
                src={selectMovie?.profile_image}
                alt='Image Description'
              />
              <div className='py-5 text-left '>
                <h4 className='text-[#6d1d9b] '>{selectMovie?.movie_title}</h4>
                <p className=' py-2  text-xs text-gray-500 dark:text-gray-500'>
                  {selectMovie?.movie_length}
                </p>
              </div>
            </div>
          )}

          <div className='flex justify-between py-5'>
            <div>
              <ul>
                <li className='flex items-center my-5 text-sm'>
                  {<FaBeer className='mr-2 ' />}Location
                </li>

                <li className='flex items-center my-5 text-sm'>
                  {' '}
                  {<FaBeer className='mr-2 ' />} Show Date
                </li>
                <li className='flex items-center my-5 text-sm'>
                  {' '}
                  {<FaBeer className='mr-2' />}Hall Name
                </li>
                <li className='flex items-center my-5 text-sm'>
                  {' '}
                  {<FaBeer className='mr-2' />} Show Time
                </li>
                <li className='flex items-center my-5 text-sm'>
                  {' '}
                  {<FaBeer className='mr-2' />} Seat Type
                </li>
                <li className='flex items-center my-5 text-sm'>
                  {' '}
                  {<FaBeer className='mr-2' />} Ticket Quantity
                </li>
                <li className='flex items-center my-5 text-sm'>
                  {' '}
                  {<FaBeer className='mr-2' />} Selected Seat
                </li>
                <li className='flex items-center my-5 text-sm'>
                  {' '}
                  {<FaBeer className='mr-2' />} Total Amount
                </li>
              </ul>
            </div>
            <div className='text-[#6d1d9b]'>
              <ul>
                <li className='my-5 text-sm font-bold'>BSC</li>
                <li className='my-5 text-sm font-bold'>
                  {selectDate?.showDate ? (
                    <>
                      <MonthName name={selectDate?.showDate} />{' '}
                      <DateName name={selectDate?.showDate} />
                    </>
                  ) : (
                    '- -'
                  )}
                </li>
                <li className='text-sm font-bold my-5'> Hall 1 </li>
                <li className='text-sm font-bold my-5'>
                  {' '}
                  {slectTime ? slectTime : '- -'}{' '}
                </li>
                <li className='text-sm font-bold  my-5'>
                  {' '}
                  {selectType?.title ? selectType?.title : '- -'}{' '}
                </li>
                <li className='text-sm font-bold   my-5'>
                  {' '}
                  {count ? count : '- -'}{' '}
                </li>
                <li className='text-sm font-bold my-5'>
                  {' '}
                  {selectSit
                    ? selectSit.map((item, index) => {
                        if (index === item.length - 1) {
                          return <span key={index}> {item.title} </span>;
                        } else {
                          return <span key={index}> {`${item.title},`} </span>;
                        }
                      })
                    : '- -'}
                </li>
                <li className='text-sm font-bold  my-5'>
                  {parseInt(
                    selectType?.value === undefined
                      ? ''
                      : selectType?.value.replace(/\D/g, '')
                  ) *
                    count >
                  0
                    ? parseInt(
                        selectType?.value === undefined
                          ? ''
                          : selectType?.value.replace(/\D/g, '')
                      ) * count
                    : 0}
                </li>
                {/* <li className="text-[#6d1d9b] my-5">- -</li> */}
              </ul>
            </div>
          </div>

          <div className=''>
            <label
              htmlFor='input-label-with-helper-text '
              className='block text-gray-500 text-left text-sm font-medium mb-2 '
            >
              Ticket For
            </label>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className='text-start'
            >
              <FromInput
                type='text'
                name='userName'
                placeholder='Enter Full Name'
                register={register}
                errors={errors}
                required={true}
              />
              <FromInput
                type='number'
                name='phoneNumber'
                placeholder='Enter PhoneNumber'
                register={register}
                errors={errors}
                required={true}
              />

              <button
                type='submit'
                className='py-2 px-2 rounded-md border border-transparent font-semibold bg-purple-500 text-white hover:bg-purple-600  focus:ring-purple-500  transition-all text-sm dark:focus:ring-offset-gray-800'
              >
                Purchase Ticket
              </button>
            </form>

            <p
              className='text-xs text-left text-gray-500 mt-2'
              id='hs-input-helper-text'
            >
              By clicking the Purchase Tickets you are accepting{' '}
              <a
                href='#'
                className='text-[#6d1d9b] font-semibold'
              >
                {' '}
                Terms & Conditions
              </a>{' '}
              of Star Cineplex.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TicketSummary;
